import { useState, useEffect } from 'react';
import './styles.css'
import Navbar from '../components/Navbar'
import MainHeading from '../components/MainHeading'
import  Footer from '../components/Footer';
import {  getAllFaqs } from './../../../api'
import whatsapp from './../images/whatsapp.svg'

function Faqs(){
  const [faqs, setFaqs] = useState([
    {
      question: "How long does it take for the process?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Orci lacus lobortis netus dignissim. Dignissim vitae, dui leo fusce a. Suspendisse risus aliquam leo non vel id. Laoreet nisl est eu."
    }
  ])



  useEffect(async () => {
    const response = await getAllFaqs();
    console.log(response.data.allFaqs)
    setFaqs(response.data.allFaqs)
  },[])


  return(
    <>
      <Navbar />
      <main>
        <a className="whatsapp" href="//api.whatsapp.com/send?phone=+919871013411"><img src={whatsapp} alt="send a message" /></a>
        <MainHeading heading="FAQ’S"/>
        <div className="faqs__container">
          {faqs.length===0 ?
            <h4 className="no__show">No faq to show</h4>
            :faqs.map((faq)=>(
            <div className="faqs__faq">
              <p className="faq__question">{faq.ques}</p>
              <p className="faq__answer">{faq.ans}</p>
            </div>
          ))}
       </div>
      </main>
      <Footer />
    </>
  )
}

export default Faqs
